import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide09Metrics({
  index
}: SlideProps) {
  return <InteriorSlide surface data-id="element-195">
      <SlideHeader eyebrow="6-Month Proposal" data-id="element-196">
        6-month model: strong first campaign wave
      </SlideHeader>

      <div className="flex-1 flex flex-col max-w-5xl mx-auto w-full" data-id="element-197">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed mb-10" data-id="element-198">
          The 6-month proposal gives GSK Morocco a strong first campaign wave
          and enough monthly activity to measure performance, gather HCP
          behavioral insights, and optimize the Amoxil communication approach.
        </motion.p>

        <div className="flex flex-col gap-6" data-id="element-199">
          {/* Highlighted Campaign Cost */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="bg-white rounded-3xl shadow-lg border-2 border-[var(--brand)] p-8 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden" data-id="element-200">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[var(--brand)]/5 rounded-bl-full -mr-32 -mt-32" data-id="element-201" />
            <div data-id="element-202">
              <h3 className="text-2xl font-bold text-[var(--fg)] mb-2" data-id="element-203">
                Monthly Campaign Adaptation
              </h3>
              <p className="text-[var(--muted)] text-lg" data-id="element-204">
                High-quality interactive campaigns at scale.
              </p>
            </div>
            <div className="text-center md:text-right" data-id="element-205">
              <div className="text-5xl font-extrabold text-[var(--brand)]" data-id="element-206">
                €600
              </div>
              <div className="text-sm font-bold text-[var(--muted)] uppercase tracking-wider mt-1" data-id="element-207">
                per campaign
              </div>
              <div className="text-sm font-medium text-[var(--fg)] mt-2" data-id="element-208">
                Total for 6 months: €3,600
              </div>
            </div>
          </motion.div>

          {/* Initial Master Costs */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-209">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 0.6
          }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-6 flex flex-col" data-id="element-210">
              <div className="text-xs font-bold text-[var(--muted)] uppercase tracking-wider mb-2" data-id="element-211">
                Initial Cost
              </div>
              <h4 className="text-xl font-bold text-[var(--fg)] mb-4" data-id="element-212">
                Master Teaser
              </h4>
              <div className="text-3xl font-bold text-[var(--fg)] mb-4" data-id="element-213">
                €2,500
              </div>
              <div className="mt-auto pt-4 border-t border-black/5" data-id="element-214">
                <div className="text-sm text-[var(--muted)]" data-id="element-215">
                  Amortized over 6 months:
                </div>
                <div className="text-lg font-bold text-[var(--brand)]" data-id="element-216">
                  €416.67{' '}
                  <span className="text-sm font-normal text-[var(--muted)]" data-id="element-217">
                    / campaign
                  </span>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.6,
            duration: 0.6
          }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-6 flex flex-col" data-id="element-218">
              <div className="text-xs font-bold text-[var(--muted)] uppercase tracking-wider mb-2" data-id="element-219">
                Initial Cost
              </div>
              <h4 className="text-xl font-bold text-[var(--fg)] mb-4" data-id="element-220">
                Master Trailer / Microsite
              </h4>
              <div className="text-3xl font-bold text-[var(--fg)] mb-4" data-id="element-221">
                €3,500
              </div>
              <div className="mt-auto pt-4 border-t border-black/5" data-id="element-222">
                <div className="text-sm text-[var(--muted)]" data-id="element-223">
                  Amortized over 12 months:
                </div>
                <div className="text-lg font-bold text-[var(--brand)]" data-id="element-224">
                  €291.67{' '}
                  <span className="text-sm font-normal text-[var(--muted)]" data-id="element-225">
                    / campaign
                  </span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Total */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.7,
          duration: 0.6
        }} className="bg-[var(--brand)] rounded-2xl shadow-md p-6 flex items-center justify-between text-white" data-id="element-226">
            <div className="font-bold text-xl uppercase tracking-wider" data-id="element-227">
              Total 6-month proposal
            </div>
            <div className="font-bold text-3xl" data-id="element-228">€9,600</div>
          </motion.div>
        </div>
      </div>
    </InteriorSlide>;
}